import { previous_month as e } from "./previous_month.js";
// src/design/forms/datepicker/calendar-engine/use-cases/nepali_date/previous_year.ts
var t = (t) => e(t) === 12 ? t.bsYear - 1 : t.bsYear;
export { t as previous_year };

//# sourceMappingURL=previous_year.js.map